import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ActiveLoyaltyIcon: React.FC<SvgIconDefaultProps> = ({ className }) => {
  return (
    <CustomSvg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.32506 12.2167L2.0584 10.95C1.54173 10.4334 1.54173 9.58335 2.0584 9.06668L3.32506 7.8C3.54172 7.58333 3.71672 7.15833 3.71672 6.85833V5.06669C3.71672 4.33336 4.31673 3.73333 5.05006 3.73333H6.84172C7.14172 3.73333 7.56673 3.55835 7.78339 3.34168L9.05005 2.075C9.56672 1.55833 10.4167 1.55833 10.9334 2.075L12.2001 3.34168C12.4167 3.55835 12.8417 3.73333 13.1417 3.73333H14.9334C15.6667 3.73333 16.2667 4.33336 16.2667 5.06669V6.85833C16.2667 7.15833 16.4417 7.58333 16.6584 7.8L17.9251 9.06668C18.4417 9.58335 18.4417 10.4334 17.9251 10.95L16.6584 12.2167C16.4417 12.4333 16.2667 12.8583 16.2667 13.1583V14.95C16.2667 15.6833 15.6667 16.2833 14.9334 16.2833H13.1417C12.8417 16.2833 12.4167 16.4583 12.2001 16.675L10.9334 17.9417C10.4167 18.4584 9.56672 18.4584 9.05005 17.9417L7.78339 16.675C7.56673 16.4583 7.14172 16.2833 6.84172 16.2833H5.05006C4.31673 16.2833 3.71672 15.6833 3.71672 14.95V13.1583C3.71672 12.85 3.54172 12.425 3.32506 12.2167Z"
        fill="#286AF6"
      />
      <path
        d="M12.4999 13.3334C12.0332 13.3334 11.6582 12.9584 11.6582 12.5001C11.6582 12.0417 12.0332 11.6667 12.4915 11.6667C12.9499 11.6667 13.3249 12.0417 13.3249 12.5001C13.3249 12.9584 12.9582 13.3334 12.4999 13.3334Z"
        fill="white"
      />
      <path
        d="M7.50842 8.33317C7.04176 8.33317 6.66675 7.95817 6.66675 7.49984C6.66675 7.0415 7.04175 6.6665 7.50008 6.6665C7.95841 6.6665 8.33341 7.0415 8.33341 7.49984C8.33341 7.95817 7.96676 8.33317 7.50842 8.33317Z"
        fill="white"
      />
      <path
        d="M7.50011 13.1249C7.34178 13.1249 7.18345 13.0666 7.05845 12.9416C6.81678 12.6999 6.81678 12.2999 7.05845 12.0582L12.0584 7.0582C12.3001 6.81654 12.7001 6.81654 12.9418 7.0582C13.1834 7.29987 13.1834 7.69992 12.9418 7.94159L7.94178 12.9416C7.81678 13.0666 7.65845 13.1249 7.50011 13.1249Z"
        fill="white"
      />
    </CustomSvg>
  );
};

export default ActiveLoyaltyIcon;
